export default {
  call: 'CALL',
  email: 'EMAIL',
  todo: 'TO-DO'
};
